module.exports = __webpack_public_path__ + "img/noImg.84c110f2.png";